module.exports = __webpack_public_path__ + "html/notification-toast-wrap.template.html";